import React from "react";
import { PrestacaoContasPage } from "./prestacaoContas.page";
import { PrestacaoContasProvider } from "./context/prestacao-contas-context";

export function PrestacaoContasFactory() {
    return (
        <PrestacaoContasProvider>
            <PrestacaoContasPage></PrestacaoContasPage>
        </PrestacaoContasProvider>
    );
}
